/*
@license
  Expanse by Archetype Themes (https://archetypethemes.co)
  Access unminified JS in assets/theme.js

  Use this event listener to run your own JS outside of this file.
  Documentation - https://archetypethemes.co/blogs/expanse/javascript-events-for-developers

  document.addEventListener('page:loaded', function() {
    // Page has loaded and theme assets are ready
  });
*/

if (console && console.log) {
  console.log("Modded theme (" + theme.settings.themeVersion + ") by Realm Web Design | Learn more at https://realmwebdesign.com");
}

(function () {
  "use strict";

  if (window.Shopify && window.Shopify.theme && navigator && navigator.sendBeacon && window.Shopify.designMode) {
    navigator.sendBeacon('https://api.archetypethemes.co/api/beacon', new URLSearchParams({
      shop: window.Shopify.shop,
      themeName: window.theme && window.theme.settings && `${window.theme.settings.themeName} v${window.theme.settings.themeVersion}`,
      role: window.Shopify.theme.role,
      route: window.location.pathname,
      themeId: window.Shopify.theme.id,
      themeStoreId: window.Shopify.theme.theme_store_id || 0,
      isThemeEditor: !!window.Shopify.designMode
    }))
  }

  theme.customerTemplates = function() {
    checkUrlHash();
    initEventListeners();
    resetPasswordSuccess();
    customerAddressForm();
  
    function checkUrlHash() {
      var hash = window.location.hash;
  
      // Allow deep linking to recover password form
      if (hash === '#recover') {
        toggleRecoverPasswordForm();
      }
    }
  
    function toggleRecoverPasswordForm() {
      var passwordForm = document.getElementById('RecoverPasswordForm').classList.toggle('hide');
      var loginForm = document.getElementById('CustomerLoginForm').classList.toggle('hide');
    }
  
    function initEventListeners() {
      // Show reset password form
      var recoverForm = document.getElementById('RecoverPassword');
      if (recoverForm) {
        recoverForm.addEventListener('click', function(evt) {
          evt.preventDefault();
          toggleRecoverPasswordForm();
        });
      }
  
      // Hide reset password form
      var hideRecoverPassword = document.getElementById('HideRecoverPasswordLink');
      if (hideRecoverPassword) {
        hideRecoverPassword.addEventListener('click', function(evt) {
          evt.preventDefault();
          toggleRecoverPasswordForm();
        });
      }
    }
  
    function resetPasswordSuccess() {
      var formState = document.querySelector('.reset-password-success');
  
      // check if reset password form was successfully submitted
      if (!formState) {
        return;
      }
  
      // show success message
      document.getElementById('ResetSuccess').classList.remove('hide');
    }
  
    function customerAddressForm() {
      var newAddressForm = document.getElementById('AddressNewForm');
      var addressForms = document.querySelectorAll('.js-address-form');
  
      if (!newAddressForm || !addressForms.length) {
        return;
      }
  
      // Country/province selector can take a short time to load
      setTimeout(function() {
        document.querySelectorAll('.js-address-country').forEach(el => {
          var countryId = el.dataset.countryId;
          var provinceId = el.dataset.provinceId;
          var provinceContainerId = el.dataset.provinceContainerId;
  
          new Shopify.CountryProvinceSelector(
            countryId,
            provinceId,
            {
              hideElement: provinceContainerId
            }
          );
        });
      }, 1000);
  
      // Toggle new/edit address forms
      document.querySelectorAll('.address-new-toggle').forEach(el => {
        el.addEventListener('click', function() {
          newAddressForm.classList.toggle('hide');
        });
      });
  
      document.querySelectorAll('.address-edit-toggle').forEach(el => {
        el.addEventListener('click', function(evt) {
          var formId = evt.currentTarget.dataset.formId;
          document.getElementById('EditAddress_' + formId).classList.toggle('hide');
        });
      });
  
      document.querySelectorAll('.address-delete').forEach(el => {
        el.addEventListener('click', function(evt) {
          var formId = evt.currentTarget.dataset.formId;
          var confirmMessage = evt.currentTarget.dataset.confirmMessage;
  
          if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
            if (Shopify) {
              Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
            }
          }
        })
      });
    }
  };
  

  /*============================================================================
    Things that don't require DOM to be ready
  ==============================================================================*/

  /*============================================================================
    Things that require DOM to be ready
  ==============================================================================*/
  function DOMready(callback) {
    if (document.readyState != "loading") callback();
    else document.addEventListener("DOMContentLoaded", callback);
  }

  DOMready(function () {
    if (theme.settings.isCustomerTemplate) {
      theme.customerTemplates();
    }

    document.dispatchEvent(new CustomEvent("page:loaded"));
  });
})();


document.addEventListener("DOMContentLoaded", (event) => {
    $('body').on('click','.cart__item .cart__item-remove .cart__remove-bundle', function(evt) {
    evt.preventDefault()
    var input = $(this).parents('.cart__item').find('.cart__item-quantity input.js-qty__num')
    input.val(0);
    setTimeout( ()=> {
    // console.log("SIBLING",input.siblings('.js-qty__adjust--minus'))
    input.siblings('.js-qty__adjust--minus').trigger('click')
    },100)
  });

  // document.addEventListener('DOMContentLoaded', function() {
    var audioElements = document.querySelectorAll('.grid__item.grid-article audio');
    // console.log("audioElements::",audioElements)

    audioElements.forEach((audio) => {
      audio.addEventListener('play', () => {
        audioElements.forEach((otherAudio) => {
          if (otherAudio !== audio) {
            otherAudio.pause();
            otherAudio.currentTime = 0; // Optional: rewind to start
          }
        });
      });
    });
  // });

  if(window.enable_ship_date){
    if (!customElements.get('cart-ship-date')) {
      class CartShipDate extends HTMLElement {
        constructor() {
          super();
          this.openPopupBtn = this.querySelector('.js-ship-popup-open');
          this.closePopupBtn = this.querySelector('.js-ship-popup-close');
          this.popupWrapper = this.querySelector('.js-ship-popup-wrapper');
          this.shipAsapBtn = this.querySelector('.js-ship-asap-btn');
          this.popup = this.popupWrapper.querySelector('.js-ship-popup');
          this.deliveryInfo = this.popupWrapper.querySelector('.js-ship-selected-info');
          this.selectedDate = this.popupWrapper.querySelector('.js-ship-selected-date');
          this.hiddenInput = this.popupWrapper.querySelector('.js-ship-input-hidden');
          this.submitBtn = this.querySelector('.js-ship-date-submit');


          this.openPopupBtn.addEventListener('click', () => {
            this.popupWrapper.classList.add('is-visible');
          })

          this.closePopupBtn.addEventListener('click', () => {
            this.closePopup();
          })

          this.popupWrapper.addEventListener('click', (e) => {
            let isClickInside = this.popup.contains(e.target);
            if (!isClickInside) {
              this.closePopup()
            }
          });

          this.submitBtn.addEventListener('click', () => {
            this.onSubmit();
          })

          this.shipAsapBtn.addEventListener('click', () => {
            this.updateCartAttributes();
            this.querySelector('.js-custom-select-btn').textContent = this.shipAsapBtn.textContent;
            this.openPopupBtn.textContent = this.openPopupBtn.getAttribute('data-option-value');
            this.deliveryInfo.classList.remove('is-visible');
            this.hiddenInput.value = '';
          })

          this.initDatepicker();
        }



        initDatepicker () {
          const _this = this;

          flatpickr("#CartShipDatePicker", {
            inline: true,
            defaultDate: this.hiddenInput.value,
            minDate: new Date().fp_incr(1),
            maxDate: new Date().fp_incr(14),
            dateFormat: "m/d/Y",
            disable: [
              function(date) {
                return (date.getDay() === 0 || date.getDay() === 6);
              }
            ],
            locale: {
              firstDayOfWeek: 1
            },
            onChange: function(selectedDates, dateStr, instance) {
              _this.onDateChange(dateStr)
            },
            onReady: function(selectedDates, dateStr, instance) {
              if (_this.hiddenInput.value) {
                _this.onDateChange(_this.hiddenInput.value);
              }
            }
          });
        }

        closePopup () {
          this.popupWrapper.classList.remove('is-visible');
          console.log(this.hiddenInput.value)
          if (!this.hiddenInput.value) {
            this.shipAsapBtn.click();
          }
        }

        onDateChange (date) {
          if (!date) return;
          const parts = date.split("/");
          const month = parseInt(parts[0], 10) - 1;
          const day = parseInt(parts[1], 10);
          const dateObj = new Date(2025, month, day);
          const options = { month: "long", day: "numeric" };
          const formatted = dateObj.toLocaleDateString("en-US", options);

          this.deliveryInfo.classList.add('is-visible');
          this.selectedDate.textContent = formatted;
          this.hiddenInput.value = date;
          this.submitBtn.removeAttribute('disabled');
        }

        onSubmit() {
          this.querySelector('.js-custom-select-btn').textContent = this.hiddenInput.value;
          this.openPopupBtn.textContent = this.hiddenInput.value;
          this.closePopup();
          this.updateCartAttributes(this.hiddenInput.value);
        }

        updateCartAttributes(date) {
          fetch(window.Shopify.routes.root + 'cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              attributes: {
                '_ship_date': date ? date : ''
              }
            })
          })
            .then(res => res.json())
            .then(data => {
              document.querySelector('custom-select').classList.remove('open');
              document.querySelector('.cart__item-row button.cart__checkout[name="checkout"]').disable = false;
            })
            .catch(err => {
              console.error(err);
            });
        }
      }

      // console.log("CartShipDate::",CartShipDate)
      customElements.define('cart-ship-date', CartShipDate);
    }

    document.addEventListener('click', function(evt){
      if(!evt.target.closest('custom-select')){
        if(document.querySelector('.site-header__drawer.site-header__cart').classList.contains('is-active') && document.querySelector('custom-select').classList.contains('open')){
          document.querySelector('custom-select').classList.remove('open');
        }
      }
    })
  }
  
  if(window.enable_age_validate){
    setTimeout(()=>{
      const dropDownBtn = document.querySelector('.js-custom-select-btn')
      if(dropDownBtn){
        dropDownBtn.addEventListener('click', function(){
          dropDownBtn.closest('custom-select').classList.toggle('open')
        })
      }

      const ageValidateInput = document.querySelector("#age-gate-input");
      const cartCheckoutBtn = document.body.classList.contains('template-cart')? document.querySelector('.template-cart .cart__page button.cart__checkout[name="checkout"]') : document.querySelector('button.cart__checkout[name="checkout"]')
      if (ageValidateInput && cartCheckoutBtn) {
        // Check if sessionStorage already has flag
        const ageGateChecked = sessionStorage.getItem('ageGateChecked') === 'true';

        // Set input state from session
        if (ageGateChecked) {
          ageValidateInput.checked = true;
        }


        // Initial state
        updateButtonState();

        // Event listener
        ageValidateInput.addEventListener('change', function () {
          if (ageValidateInput.checked) {
            sessionStorage.setItem('ageGateChecked', 'true');
          } else {
            sessionStorage.removeItem('ageGateChecked');
          }
          updateButtonState();
        });

        // Function to update button based on checkbox
        function updateButtonState() {
          if (window.theme && window.theme.applyCartCheckoutGate) {
            window.theme.applyCartCheckoutGate();
          } else if (ageValidateInput.checked) {
            cartCheckoutBtn.removeAttribute('disabled');
          } else {
            cartCheckoutBtn.setAttribute('disabled', 'disabled');
          }
        }
      }
      
    },1000)
  }
});


document.addEventListener("DOMContentLoaded", function () {
  const maxWords = theme.settings.noteWordLimit;

  document.querySelectorAll(".cart-note").forEach(function(textarea) {
    const counter = textarea.nextElementSibling;

    function updateWordCount() {
      let words = textarea.value.trim().split(/\s+/).filter(Boolean);
      let wordCount = words.length;

      if (wordCount > maxWords) {
        words = words.slice(0, maxWords);
        textarea.value = words.join(" ");
        wordCount = maxWords;
      }

      if (counter) {
        counter.textContent = wordCount + " / " + maxWords + " words";
        counter.style.color = wordCount >= maxWords ? "red" : "";
      }
    }

    textarea.addEventListener("input", updateWordCount);
    updateWordCount();
  });

  //equalizeMetaHeight('body.template-collection .collection-grid .grid-item__meta-main');
});

function equalizeMetaHeight(selector) {
  if(window.innerWidth < 768){
    const items = document.querySelectorAll(selector);

    // Reset height
    items.forEach(item => {
      item.style.height = 'auto';
    });

    // Find max height
    let maxHeight = 0;
    items.forEach(item => {
      if (item.offsetHeight > maxHeight) {
        maxHeight = item.offsetHeight;
      }
    });

    // Apply max height
    items.forEach(item => {
      item.style.height = `${maxHeight}px`;
    });
  }
}

// Run on page load
// window.addEventListener('load', equalizeMetaHeight('body.template-collection .collection-grid .grid-item__meta-main'));

// Run on resize
// window.addEventListener('resize', equalizeMetaHeight('body.template-collection .collection-grid .grid-item__meta-main'));